class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper') || document.querySelector('.abode-header-wrapper');

    this.mainDetailsToggle.addEventListener('keyup', this.onKeyUp.bind(this));

    const overlay = this.mainDetailsToggle.querySelector('.abode-mega-menu__overlay');
    if (overlay) {
      overlay.addEventListener('click', () => this.close());
    }

    // Open mega-menu on hover (desktop only)
    this.hoverTimeout = null;
    this.addEventListener('mouseenter', () => {
      if (window.innerWidth < 990) return;
      clearTimeout(this.hoverTimeout);
      this.open();
    });
    this.addEventListener('mouseleave', () => {
      if (window.innerWidth < 990) return;
      this.hoverTimeout = setTimeout(() => this.close(), 150);
    });
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }

  onKeyUp(event) {
    if (event.code === 'Escape') {
      this.close();
      this.mainDetailsToggle.querySelector('summary').focus();
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) {
      summary.setAttribute('aria-expanded', this.mainDetailsToggle.open);
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
